import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('lf_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses (expired/invalid token)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle session timeout (HIPAA)
    if (error.response?.status === 440) {
      window.dispatchEvent(new CustomEvent('session-timeout', { detail: { status: 440 } }));
      return Promise.reject(error);
    }
    if (error.response?.status === 401 && !error.config?.url?.includes("/auth/login") && !error.config?.url?.includes("/auth/register")) {
      localStorage.removeItem('lf_token');
      localStorage.removeItem('lf_user');
      localStorage.removeItem('lf_tenant');
      const path = window.location.pathname;
      if (path !== '/login' && path !== '/register') {
        window.location.href = '/login';
      }
      // Return a rejected promise with a silent error (won't trigger unhandled rejection overlays)
      const silentError = new Error('Session expired');
      silentError.isSessionExpired = true;
      return Promise.reject(silentError);
    }
    return Promise.reject(error);
  }
);

// Background API instance — identical to api but marks requests as background
// so the session timeout middleware won't reset the activity timer
const backgroundApi = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
    'x-background-request': 'true',
  },
});

// Share the same JWT interceptor
backgroundApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('lf_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Share the same 440/401 response handling
backgroundApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 440) {
      window.dispatchEvent(new CustomEvent('session-timeout', { detail: { status: 440 } }));
      return Promise.reject(error);
    }
    if (error.response?.status === 401 && !error.config?.url?.includes("/auth/login") && !error.config?.url?.includes("/auth/register")) {
      localStorage.removeItem('lf_token');
      localStorage.removeItem('lf_user');
      localStorage.removeItem('lf_tenant');
      const path = window.location.pathname;
      if (path !== '/login' && path !== '/register') {
        window.location.href = '/login';
      }
      const silentError = new Error('Session expired');
      silentError.isSessionExpired = true;
      return Promise.reject(silentError);
    }
    return Promise.reject(error);
  }
);

export { backgroundApi };
export default api;
